import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const HumanResourcesPage = () => {
  const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref3, inView3] = useInView({ triggerOnce: true, threshold: 0.1 });

  const benefits = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'Sağlık Sigortası',
      description: 'Çalışanlarımız ve ailelerini kapsayan özel sağlık sigortası',
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Eğitim Desteği',
      description: 'Mesleki gelişim için eğitim programları ve sertifikasyon desteği',
    },
    {
      icon: 'ri-trophy-line',
      title: 'Performans Primi',
      description: 'Başarı odaklı performans değerlendirme ve prim sistemi',
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Yemek Kartı',
      description: 'Günlük yemek kartı desteği',
    },
    {
      icon: 'ri-bus-line',
      title: 'Servis İmkanı',
      description: 'Ücretsiz personel servisi hizmeti',
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Esnek Çalışma',
      description: 'İş-yaşam dengesi için esnek çalışma saatleri',
    },
  ];

  const departments = [
    {
      icon: 'ri-settings-3-line',
      name: 'Üretim',
      description: 'Modern üretim tesislerimizde kaliteli üretim süreçlerini yönetme',
      positions: ['Üretim Operatörü', 'Vardiya Amiri', 'Üretim Müdürü'],
    },
    {
      icon: 'ri-flask-line',
      name: 'Kalite Kontrol',
      description: 'Ürün kalitesini garanti altına alma ve test süreçlerini yönetme',
      positions: ['Kalite Kontrol Teknisyeni', 'Laboratuvar Sorumlusu', 'Kalite Müdürü'],
    },
    {
      icon: 'ri-line-chart-line',
      name: 'Satış & Pazarlama',
      description: 'Müşteri ilişkileri ve pazar geliştirme faaliyetleri',
      positions: ['Satış Temsilcisi', 'Pazarlama Uzmanı', 'Satış Müdürü'],
    },
    {
      icon: 'ri-customer-service-2-line',
      name: 'Müşteri Hizmetleri',
      description: 'Müşteri memnuniyeti ve sipariş yönetimi',
      positions: ['Müşteri Temsilcisi', 'Sipariş Koordinatörü', 'Müşteri İlişkileri Müdürü'],
    },
    {
      icon: 'ri-tools-line',
      name: 'Teknik Destek',
      description: 'Makine bakım, onarım ve teknik altyapı yönetimi',
      positions: ['Bakım Teknisyeni', 'Elektrik Teknisyeni', 'Teknik Müdür'],
    },
    {
      icon: 'ri-briefcase-line',
      name: 'İdari İşler',
      description: 'İnsan kaynakları, finans ve genel yönetim',
      positions: ['İK Uzmanı', 'Muhasebe Elemanı', 'İdari İşler Müdürü'],
    },
  ];

  const values = [
    {
      icon: 'ri-team-line',
      title: 'Ekip Ruhu',
      description: 'Birlikte çalışma ve dayanışma kültürü',
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'İnovasyon',
      description: 'Yenilikçi fikirlere açık ortam',
    },
    {
      icon: 'ri-arrow-up-line',
      title: 'Kariyer Gelişimi',
      description: 'Sürekli öğrenme ve ilerleme fırsatları',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'İş Güvenliği',
      description: 'Güvenli ve sağlıklı çalışma ortamı',
    },
  ];

  const stats = [
    { number: '68+', label: 'Çalışan Sayısı' },
    { number: '%95', label: 'Çalışan Memnuniyeti' },
    { number: '5+', label: 'Ortalama Çalışma Süresi' },
    { number: '%30', label: 'İç Terfi Oranı' },
  ];

  return (
    <div className="min-h-screen bg-white font-poppins">
      <Navbar />

      {/* Hero Section */}
      <section className="relative min-h-[60vh] sm:min-h-[70vh] lg:min-h-screen flex items-center justify-center overflow-hidden pt-16 sm:pt-20">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/b944d06355db186077c44451a8eab837.jpg"
            alt="İnsan Kaynakları"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-navy/90 via-navy/80 to-navy/90" />
        </div>

        <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto py-12 sm:py-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="mb-6 sm:mb-8"
          >
            <span className="inline-block px-4 sm:px-6 py-2 bg-green/20 border border-green/30 rounded-full text-green text-xs sm:text-sm font-semibold uppercase tracking-wider backdrop-blur-sm">
              İnsan Kaynakları
            </span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 sm:mb-6"
          >
            Ekibimize<br className="hidden sm:block" />
            Katılın
          </motion.h1>
          
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-base sm:text-lg lg:text-xl text-white/90 mb-8 sm:mb-12 max-w-3xl mx-auto leading-relaxed px-4"
          >
            AnadoluPet ailesinde kariyer fırsatlarını keşfedin ve geleceğinizi birlikte inşa edelim
          </motion.p>
        </div>
      </section>

      {/* Stats Section */}
      <section ref={ref1} className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {stats.map((stat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                animate={inView1 ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="text-center bg-gradient-to-br from-gray-50 to-white p-6 sm:p-8 rounded-2xl border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300"
              >
                <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-teal mb-2 sm:mb-3">{stat.number}</div>
                <div className="text-sm sm:text-base text-gray-700 font-medium">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Work With Us */}
      <section ref={ref2} className="py-12 sm:py-16 lg:py-28 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={inView2 ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="text-center mb-10 sm:mb-16 lg:mb-20"
          >
            <span className="text-teal text-xs sm:text-sm font-semibold uppercase tracking-wider">/NEDEN ANADOLUPET</span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-navy mt-4 sm:mt-6 mb-4 sm:mb-6">Çalışma Kültürümüz</h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
              Çalışanlarımızın gelişimine ve mutluluğuna önem veren bir ortam
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {values.map((value, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                animate={inView2 ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white p-6 sm:p-8 rounded-2xl lg:rounded-3xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 text-center group cursor-pointer"
              >
                <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-gradient-to-br from-teal to-green rounded-xl mx-auto text-white text-3xl mb-4 sm:mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={value.icon} />
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-navy mb-3">{value.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{value.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section ref={ref3} className="py-12 sm:py-16 lg:py-28 bg-white">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={inView3 ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="text-center mb-10 sm:mb-16 lg:mb-20"
          >
            <span className="text-teal text-xs sm:text-sm font-semibold uppercase tracking-wider">/YAN HAKLAR</span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-navy mt-4 sm:mt-6 mb-4 sm:mb-6">Çalışan Avantajları</h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
              Çalışanlarımıza sunduğumuz kapsamlı yan haklar ve imkanlar
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {benefits.map((benefit, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                animate={inView3 ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-gradient-to-br from-gray-50 to-white p-6 sm:p-8 lg:p-10 rounded-2xl lg:rounded-3xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 group cursor-pointer"
              >
                <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-gradient-to-br from-teal to-green rounded-xl text-white text-2xl sm:text-3xl mb-4 sm:mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                  <i className={benefit.icon} />
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-navy mb-3">{benefit.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{benefit.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 sm:py-20 lg:py-32 bg-gradient-to-br from-navy via-navy/95 to-navy relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-0 left-0 w-96 h-96 bg-green rounded-full blur-3xl" />
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-teal rounded-full blur-3xl" />
        </div>

        <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6">
              Başvurunuzu Gönderin
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-white/90 mb-8 sm:mb-12 max-w-2xl mx-auto px-4">
              CV'nizi gönderin, sizinle iletişime geçelim
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
              <Link
                to="/contact"
                className="w-full sm:w-auto px-8 sm:px-10 lg:px-12 py-3 sm:py-4 bg-green text-white text-sm sm:text-base font-semibold rounded-lg hover:bg-green-dark hover:shadow-2xl hover:transform hover:-translate-y-1 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
              >
                Başvuru Yap
              </Link>
              <Link
                to="/about"
                className="w-full sm:w-auto px-8 sm:px-10 lg:px-12 py-3 sm:py-4 bg-transparent border-2 border-white text-white text-sm sm:text-base font-semibold rounded-lg hover:bg-white hover:text-navy hover:transform hover:-translate-y-1 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
              >
                Hakkımızda
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HumanResourcesPage;
